// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"43c2cff7","66":"e1b3a536","180":"d5d1e99e","287":"5baaa63e","320":"50339063","331":"bbb2b833","351":"6dd930a3","384":"7f491539","453":"7e369698","464":"d2fc4e3a","615":"08ee4d75","692":"67ec253a","754":"be557429","885":"90a398f4","925":"23876ac6"}[chunkId] + ".chunk.js";
};